<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <core-card [actions]="[]">
      <div class="card-title w-100">
        <div [ngClass.xl]="'float-left row pl-1'" [ngClass.md]="'float-left row pl-1'" [ngClass.sm]="'mb-075'">
          <label class="d-flex align-items-center">
            <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" />
          </label>
        </div>
        <div class="float-right">
          <div [ngClass.xl]="'w-fit d-inline-block mr-1'" [ngClass.md]="'w-fit d-inline-block mr-1'" [ngClass.sm]="'d-none'">
            <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
          </div>
          <a class="btn btn-outline-primary text-primary" (click)="modalOpen(modalCategoryAdd, null, null)" has_capability="create_notification_category">{{ 'ADD' | translate }}</a>
        </div>
      </div>
      <!--desktop-->
      <div class="card-body px-0 pb-0" *ngIf="_utilService.isDesktop">
        <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="config.headerHeight"
                       [scrollbarH]="config.scrollbarH" [rowHeight]="config.rowHeight" [limit]="tableLimit"
                       [footerHeight]="config.footerHeight" [rows]="categoriesList()"
                       [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}">
          <ngx-datatable-column name="{{'FIRSTNAME' | translate}}" prop="name" width="150" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div [ngbTooltip]="row?.description">{{ row.name }}</div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{'MENU.ROLES' | translate}}" prop="roles" width="500" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex">
                <span class="badge badge-secondary mr-025" *ngFor="let role of row.roles">{{ role.name }}</span>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{'ACTIONS' | translate}}" [sortable]="false" width="50">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div>
                <button class="bg-transparent border-0 text-secondary pr-1" (click)="modalOpen(modalCategoryEdit, row, 'edit')" has_capability="edit_notification_category">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button (click)="deleteCategory(row)" has_capability="delete_notification_category" class="bg-transparent border-0 text-danger remove-item">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
      <!--mobile - tablet-->
      <div class="card-body px-0 pb-0 w-100" *ngIf="_utilService.isMobile || _utilService.isTablet">
        <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="config.headerHeight"
                       [scrollbarH]="false" [rowHeight]="150" [limit]="tableLimit"
                       [footerHeight]="config.footerHeight" [rows]="categoriesList()"
                       [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}">
          <ngx-datatable-column name="{{'FIRSTNAME' | translate}}" prop="name" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-10">
                  <span>{{ row.name }}</span>
                  <div>
                    <span class="badge badge-secondary mr-025" *ngFor="let role of row.roles">{{ role.name }}</span>
                  </div>
                </div>
                <div class="col-2 d-flex flex-column justify-content-center pl-0">
                  <button class="pr-0 bg-transparent border-0 text-secondary mb-1"
                          (click)="modalOpen(modalCategoryEdit, row, 'edit')">
                    <i [data-feather]="'edit-2'" size="19"></i>
                  </button>
                  <button (click)="deleteCategory(row)" *ngIf="_authenticationService.hasCapability('delete_notification_category')"
                          class="pr-0 bg-transparent border-0 text-danger remove-item">
                    <i [data-feather]="'trash-2'" size="19"></i>
                  </button>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </core-card>
  </div>
</div>


<!-- Modal Edit -->
<ng-template #modalCategoryEdit let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()"
            aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "EDIT" | translate }} {{ "CATEGORY" | translate }}</h3>
    <div class="form-group">
      <label [for]="'editCategory'">{{ "CATEGORY" | translate }}<sup class="text-danger">*</sup></label>
      <input name="editCategory" [(ngModel)]="currentCategory.name" type="text" [id]="'editCategory'" class="form-control" />
      <div class="font-error"
           *ngIf="showModalErrors && (!currentCategory.name || currentCategory.name.length < 1)">{{ 'ERRORS.FIELD_CATEGORY' | translate }}
      </div>
      <div *ngIf="showModalErrors && (!!currentCategory.name && currentCategory.name.length < 4)"
           class="text-muted">{{ "INSERT_AT_LEAST_FOUR_CARACTHER" | translate }}
      </div>
    </div>
    <div class="form-group">
      <label for="newRoles">{{ "MENU.ROLES" | translate }}<sup class="text-danger">*</sup></label>
      <div>
        <ng-select id="newRoles" [(ngModel)]="addRoles"
                   [searchable]="true" [ngModelOptions]="{standalone: true}"
                   [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true"
                   [multiple]="true">
          <ng-option *ngFor="let role of this._roleService.list" [value]="role.id">
            <span class="font-small-4 font-weight-normal">{{ role.name }}</span>
          </ng-option>
        </ng-select>
        <div class="font-error"
             *ngIf="showModalErrors && (!addRoles || addRoles.length < 1)">{{ 'ERRORS.FIELD_LIST_ROLES' | translate }}
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="newDescription">{{ 'DESCRIPTION' | translate }}</label>
      <div>
                <textarea name="newDescription" id="newDescription" class="form-control" cols="30" rows="8" [(ngModel)]="newDescription"
                          [ngModelOptions]="{standalone: true}"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150"
            (click)="modal.close()"
            rippleEffect>
      {{ "ALERT.BTN_CANCEL" | translate }}
    </button>
    <button (click)="editCategoryCommunication()" type="submit" class="btn btn-primary w-150" rippleEffect>
      {{ "EDIT" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal Edit -->

<!-- Modal Add -->
<ng-template #modalCategoryAdd let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()"
            aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "ADD" | translate }} {{ "CATEGORY" | translate }}</h3>
    <div class="form-group">
      <label [for]="'newCategory'">{{ "CATEGORY" | translate }}<sup class="text-danger">*</sup></label>
      <input name="newCategory" [(ngModel)]="newCategoryCommunication" type="text" [id]="'newCategory'" class="form-control" />
      <div class="font-error"
           *ngIf="showModalErrors && (!newCategoryCommunication || newCategoryCommunication.length < 1)">{{ 'ERRORS.FIELD_CATEGORY' | translate }}
      </div>
      <div *ngIf="showModalErrors && (!!newCategoryCommunication && newCategoryCommunication.length < 4)"
           class="text-muted">{{ "INSERT_AT_LEAST_FOUR_CARACTHER" | translate }}
      </div>
    </div>
    <div class="form-group mt-025">
      <label for="roles">{{ "MENU.ROLES" | translate }}<sup class="text-danger">*</sup></label>
      <div>
        <ng-select id="roles" [(ngModel)]="addRoles" [searchable]="true" [ngModelOptions]="{standalone: true}"
                   [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [multiple]="true">
          <ng-option *ngFor="let role of _roleService.list" [value]="role.id">
            <span class="font-small-4 font-weight-normal">{{ role.name }}</span>
          </ng-option>
        </ng-select>
      </div>
      <div class="font-error" *ngIf="showModalErrors && (!addRoles || addRoles.length < 1)">{{ 'ERRORS.FIELD_LIST_ROLES' | translate }}</div>
    </div>
    <div class="form-group">
      <label for="newDescription2">{{ 'DESCRIPTION' | translate }}</label>
      <div>
                <textarea name="newDescription" id="newDescription2" class="form-control" cols="30" rows="8" [(ngModel)]="newDescription"
                          [ngModelOptions]="{standalone: true}"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>{{ "ALERT.BTN_CANCEL" | translate }}
    </button>
    <button (click)="addCategoryCommunication()" type="submit" class="btn btn-primary w-150" rippleEffect>
      {{ "ERRORS.INSERT" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal Add -->